export default "__VITE_ASSET__DVZbkkPO__"